import { merge } from 'lodash'

const config = require('apps/bankrate-calculators/common/config')
const localConfig = {
  interestRate: {
    default: 6,
    min: 0.001,
    max: 99,
    info: [{ copy: 'This is interest rate per year' }]
  }
}

export default merge(config.default, localConfig)
